import { useMemo } from "react";
import { useRecoilValue } from "recoil";

import mainStore from "src/stores/main";
import Odd from "src/common/components/odd";
import { useConfig } from "src/hooks/config";
import { getBetCalculations } from "calculation";
import selectionsStore from "src/stores/selections";
import { useTranslation } from "src/hooks/translation";
import { BetCalculationsEnum } from "src/constants/enums/betCalculations";
import upperDataStore from "src/stores/upperData";
import betBuilderStore from "src/stores/betBuilder";
import { getEffectiveTotalOdd, hasBetBuilderSelections } from "src/common/helpers/betBuilder";

const BetDetailsTotalOdd = () => {
	const t = useTranslation();
	const config = useConfig();
	const { partnerConfig, currencyConfig } = useRecoilValue(upperDataStore);
	const { betType } = useRecoilValue(mainStore);
	const { selections } = useRecoilValue(selectionsStore);
	const { groups: betBuilderGroups } = useRecoilValue(betBuilderStore);

	const { totalOdd } = useMemo(() => {
		// When the betslip contains any bet builder selections, the regular bet
		// calc lib doesn't know to collapse a card to its combined odd — compute
		// it here using the per-game combined price from get_bet_builder_odds.
		if (hasBetBuilderSelections(selections)) {
			return { totalOdd: getEffectiveTotalOdd(selections, betBuilderGroups) };
		}

		return getBetCalculations([BetCalculationsEnum.TotalOdd], {
			config,
			partnerConfig,
			betType,
			events: selections,
			currencyConfig,
		});
	}, [config, betType, partnerConfig, currencyConfig, selections, betBuilderGroups]);

	if (!totalOdd) return null;

	return (
		<div className="B-betslip-bet-details-info-row">
			<p className="B-info-row-title">{t("Odds:")}</p>
			<p className="B-info-row-number">
				<Odd price={totalOdd} />
			</p>
		</div>
	);
};

export default BetDetailsTotalOdd;
